import React from 'react';
import './CardWithBackground.scss';
import { FluidObject } from 'gatsby-image';

import GatsbyResponsiveImage from '@atoms/GatsbyResponsiveImage';
import { ImageRenderType } from '@atoms/ResponsiveSharpImg/ResponsiveSharpImg';

interface SharpImageProps {
    childImageSharp: {
        fluid: FluidObject;
    };
}

interface Props {
    altText?: string;
    url?: string;
    mobileUrl?: string;
    tabletUrl?: string;
    urlSharp?: SharpImageProps;
    mobileSharpImage?: SharpImageProps;
    tabletUrlSharp?: SharpImageProps;
    greenBackground?: boolean;
    children?: React.ReactNode;
}


const CardWithBackground: React.FC<Props> = ({
    url,
    urlSharp,
    mobileUrl,
    mobileSharpImage,
    tabletUrl,
    tabletUrlSharp,
    greenBackground = false,
    children,
    altText,
}) => {
    const tabletClassName = 'CardWithBackground--bg is-tablet';
    const mobileClassName = 'CardWithBackground--bg is-mobile';
    const desktopClassName = 'CardWithBackground--bg is-desktop';
   
    return (
        <div className="CardWithBackground">
            {greenBackground && <div className="green-gradient-background" />}
            <GatsbyResponsiveImage 
                url={url}
                urlSharp={urlSharp}
                mobileUrl={mobileUrl}
                mobileSharpImage={mobileSharpImage}
                tabletUrl={tabletUrl}
                tabletUrlSharp={tabletUrlSharp}
                desktopClassName={desktopClassName}
                tabletClassName={tabletClassName}
                mobileClassName={mobileClassName}
                altText={altText}
                type={ImageRenderType.BgImage}
            />
            <div className="CardWithBackground--inner">
                <div className="CardWithBackground--wrapper">
                    {children && children}
                </div>
            </div>
        </div>
    );
};

export default CardWithBackground;
